import Guest from '@/layouts/guest';
import React, {useEffect, useState} from 'react';
import {Container, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import StudioDetailsSidebar from "@/components/global/studios/details-sidebar";
import styles from "./details.module.scss";
import StudiosService from "@/services/studios-service";
import {ALERT} from "@/actions/types";
import {useDispatch} from "react-redux";
import Loader from "@/components/global/loader";
import { setCanonical } from '@/app/general';

const StudioDetails: React.FC = (props: any) => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [studio, setStudio] = useState<IStudioDetails | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        // get studio based on slug
        setCanonical();
        if(params.slug) {
            StudiosService.getStudio(params.slug || '').then((studio: IStudioDetails) => {
                setStudio(studio);
            }).catch((err: any) => {
                dispatch({
                    type: ALERT,
                    payload: { message: { result: 0, message: 'دریافت اطلاعات استودیوی موردنظر با خطا مواجه شد. لطفا صفحه را رفرش نمایید!' } }
                });
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [dispatch, params.slug]);

    return (
        <Guest title={studio?.title || "جزئیات استودیو"}>
            <Container className="py-5">
                {loading? <Loader /> : (
                    <Row>
                        <div className="col-lg-3 col-md-4 mb-lg-0 mb-4 mx-auto" style={{maxWidth: '400px'}}>
                            <StudioDetailsSidebar studio={studio} />
                        </div>
                        <div className="col-lg-9 col-md-8">
                            <Row>
                                <div className={styles.details}>
                                    <h2>معرفی و خدمات استودیو</h2>
                                    <p>
                                        {studio?.summary}
                                    </p>
                                    <p>
                                        <i className="fa fa-map-marker-alt" /> {studio?.address}
                                    </p>
                                </div>
                            </Row>
                        </div>
                    </Row>
                )}
            </Container>
        </Guest>
    );
}

export default StudioDetails;
